import axios from "axios";
import axiosUtil from "@plannel/utils/axios-bigint"
import authService from "./auth-service";

const googleSignInSSO = async (tenant, params) => {
  const response = await axios.post("/sso/googleSSOSignIn", {
    ...params
  }, {
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": authService.getTenant(tenant)
    },
    transformResponse: axiosUtil.transformResponse
  });
  if (response.data.accessToken) {
    localStorage.setItem("user", axiosUtil.jsonbigStringfy(response.data));
  }
  return response.data;
}

const ssoService = {
  googleSignInSSO
};

export default ssoService;